<template>
    <div>
        <template v-if="fitmentSummary && fitments?.length > 0">
            <div class="fitment-count badge bg-dark-blue text-uppercase fw-normal mt-2" data-bs-toggle="tooltip" data-bs-placement="top" :title="fitmentNames">
                {{ fitments.length }} oem fitment{{ fitments.length > 1 ? 's' : '' }}
            </div>
        </template>
        <template v-else-if="fitments?.length > 0">
            <div class="fitments mb-1">
                <span v-for="fitment in fitments" class="mr-2" :key="fitment.id">
                    <img v-if="fitment.name && fitment.fitment_logo_url" 
                        class=""
                        :src="this.$root.createUrl(fitment.fitment_logo_url)"
                        width="30" 
                        height="30" 
                        data-bs-toggle="tooltip" 
                        data-bs-placement="top" 
                        :title="fitment.name + ' approved'"
                    />
                </span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['fitments', 'fitmentSummary'],
        computed: {
            fitmentNames() {
                const names = [];

                _.forEach(this.fitments, function(fitment) {
                    names.push(fitment.name != null ? fitment.name : fitment.code);
                });

                return _join(names, ', ');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .fitments {
        position: absolute;
        top: 0;
        left: 0;
        max-width: 60px;
        span {
            float: left;
        }
    }
</style>